import React from "react";
import { Button, WithRecord } from "react-admin";

import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import PreviewIcon from "@mui/icons-material/Preview";

import CloneVersion from "./CloneVersion";
import DeleteVersion from "./DeleteVersion";
import EditVersion from "./EditVersion";
import { settings } from "app/settings";

const VersionActions = ({ mode, pageName, route, isAvaliableForDel }) => {
  let editAction, viewAction, resource;

  switch (mode) {
    case "page":
      editAction = "edit-page";
      viewAction = "view-page";
      resource = "page-versions-cms";
      break;
    case "component":
      editAction = "edit-component";
      viewAction = "view-component";
      resource = "custom-component-versions-cms";
      break;
    default:
  }

  return (
    <>
      <WithRecord
        render={record => (
          <>
            <Button
              href={`${settings.editApp}/${viewAction}?version=${record.id}`}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<PreviewIcon />}
              label="Преглед"
            />
            {record.isDraft && (
              <Button
                href={`${settings.editApp}/${editAction}?version=${record.id}`}
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<AppRegistrationIcon />}
                label="CMS"
              />
            )}
            <CloneVersion
              record={record}
              resource={resource}
              pageName={pageName}
              route={route}
              mode={mode}
            />
            {record.isDraft && (
              <EditVersion
                record={record}
                resource={resource}
                mode={mode}
              />
            )}
            {isAvaliableForDel && (
              <DeleteVersion
                record={record}
                resource={resource}
              />
            )}
          </>
        )}
      />
    </>
  );
};

export default VersionActions;
